import React from 'react'
import { string, bool } from 'prop-types'
import classnames from 'classnames'

import intl from 'react-intl-universal'
import { branch } from 'baobab-react/higher-order'
import triggerEvent from 'utils/dataLayer'
import trackEventFbq from 'utils/fbPixel'

import Button from 'components/atoms/Button'
import AuthenticatedLink from 'components/molecules/AuthenticatedLink'

const ScholarshipRegistrationButton = ({
  slug,
  url,
  isTracking,
  isOpen,
  isRound,
  hasTriggered,
  setHasTriggered,
}) => {
  const trackEvent = () => {
    isOpen && triggerEvent('ga/scholarship/register')
    if (slug === 'quipper-scholarship-award-2021' && !hasTriggered) {
      trackEventFbq('SubmitApplication')
      setHasTriggered(true)
    }
  }
  const openNewTab = isOpen ? ({
    target: '_blank',
    rel: 'noopener',
    title: 'Click untuk mendaftar',
  }) : {}
  const classNameVal = classnames('scholarship-reg-btn btn btn-campus', {
    disabled: !isOpen,
    'scholarship-reg-btn--round': isRound,
  })
  const buttonText = isOpen ? intl.get('school.register_scholarship') : 'Pendaftaran Ditutup'

  return (
    <>
      {
        isTracking ?
          <AuthenticatedLink
            href={isOpen && `/scholarships/${slug}/registration`}
            className={classNameVal}
            onClick={trackEvent}
            linkProps={openNewTab}
            successUrl={`scholarships/${slug}/registration`}
          >
            {buttonText}
          </AuthenticatedLink> :
          <Button
            className={classNameVal}
            component="a"
            href={isOpen && url}
            onClick={trackEvent}
            linkProps={openNewTab}
          >
            {buttonText}
          </Button>
      }
      <style jsx global>
        {`
          .scholarship-reg-btn {
            font-size: 14px;
            font-weight: bold;
            padding: 14px 28px;
            border: none;
            margin: 8px 0;
            width: 100%;
            background-color: #fc7d20;
            &:hover {
              background-color: #ce5700;
            }
            &--round {
              @media screen and (max-width: 767px) {
                border-radius: 20px;
                background-color: #00c2c9;
                box-shadow: 0 2px 8px 0 rgba(107, 143, 188, 0.85);
                padding: 12px 28px;
                margin: 0;
                width: unset;
              }
            }
            @media screen and (min-width: 768px) {
              width: unset;
              margin: 8px;
            }
          }
        `}
      </style>
    </>
  )
}

ScholarshipRegistrationButton.propTypes = {
  slug: string.isRequired,
  url: string.isRequired,
  isTracking: bool,
  isRound: bool,
}

ScholarshipRegistrationButton.defaultProps = {
  isTracking: false,
  isRound: false,
}

export { ScholarshipRegistrationButton }
export default branch({
  slug: ['serverProps', 'scholarship', 'slug'],
  isOpen: ['serverProps', 'scholarship', 'registration', 'isOpen'],
  url: ['serverProps', 'scholarship', 'registration', 'url'],
  isTracking: ['serverProps', 'scholarship', 'registration', 'recordLeads'],
}, ScholarshipRegistrationButton)
